module.exports = __webpack_public_path__ + "img/br.brf1b8e36.svg";